// Author thq
// Date 2021-10-22 10:59:00

class EmAdmGroup {
constructor({
        id = null,
        sid = '',
        name = '',
        code = '',
        remark = ''}
= {}) {
    this.id = id;
    this.sid = sid;
    this.name = name;
    this.code = code;
    this.remark = remark;
}
}

function newEntity() {
return new EmAdmGroup();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.emAdmGroup.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sid',
        label: 'label.em.admin.emAdmGroup.grid.sid',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAdmGroup.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.admin.emAdmGroup.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmGroup.grid.remark',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    sidFilter : '',
    nameFilter : '',
    codeFilter : '',
    remarkFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sidFilter',
        label: 'label.em.admin.emAdmGroup.filter.sid',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAdmGroup.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.admin.emAdmGroup.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remarkFilter',
        label: 'label.em.admin.emAdmGroup.filter.remark',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sid',
        label: 'label.em.admin.emAdmGroup.entity.sid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAdmGroup.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'code',
        label: 'label.em.admin.emAdmGroup.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmGroup.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmAdmGroup, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
